import { Injectable } from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class TrustMarketplaceStatusService {
  private trustMarketplaceStatus: any;
  private trustStatusSubject = new BehaviorSubject<number | undefined>(undefined);
  private trustAdminStatusSubject = new BehaviorSubject<number | undefined>(undefined);


  constructor() { }
  setSharedData(data: any) {
    this.trustMarketplaceStatus = data;
  }

  getSharedData() {
    return this.trustMarketplaceStatus;
  }
  get trustStatus$() {
    return this.trustStatusSubject.asObservable();
  }
  get trustAdminStatus() {
    return this.trustAdminStatusSubject.asObservable();
  }
  updateTrustStatus(statusCode: number) {
    this.trustStatusSubject.next(statusCode);
  }
  updateTrustAdminStatus(tmpAdminStatus: number) {
    this.trustAdminStatusSubject.next(tmpAdminStatus);
  }
}
